import { Box, Button } from "@mui/material"
import { Link } from "react-router-dom"
import { useFindRecentSensorInstallations } from "../../api/SensorInstallApi"
import { BackButton } from "../../components/BackButton"
import { NexPageContainer } from "../../components/NexPageContainer"
import { Title } from "../../components/Typography/Typography"
import { useSensorInstallSearchFiltersWithDefaults } from "../../hooks/useNexusParams"
import { routes } from "../../routing/NexRoutes"
import { sensorInstallBaseColumns } from "./table/SensorInstallColumns"
import { SensorInstallTable } from "./table/SensorInstallTable"

const columns = sensorInstallBaseColumns.slice()
columns.unshift({
    field: "sensor",
    headerName: "Sensor Model - Serial Number",
    sortable: false,
    filterable: false,
    width: 304,
    renderCell: (params) => {
        const row = params.row
        return (
            <Button
                key={row.id}
                component={Link}
                variant={"outlined"}
                fullWidth={true}
                size="small"
                to={routes.sensorInstallationsForSensor(row.sensor.sensor_id)}
            >
                {row.sensor.sensor_model} - {row.sensor.serial_number}
            </Button>
        )
    },
})

// Query the sensor installs table to show only most recent
export const SensorInstallRecentTable = () => {
    const currentFiltersWithDefaults = useSensorInstallSearchFiltersWithDefaults()

    const sensorInstallResults = useFindRecentSensorInstallations(currentFiltersWithDefaults)
    const sensorInstallations = sensorInstallResults.data

    return (
        <NexPageContainer py={4}>
            <Title>Recent Sensor Installations</Title>
            <Box sx={{ my: 2 }}>
                <SensorInstallTable
                    columns={columns}
                    rows={sensorInstallations?.results}
                    count={sensorInstallations?.count}
                    isLoading={sensorInstallResults.isPending}
                />
            </Box>
            <BackButton />
        </NexPageContainer>
    )
}
